angular.module('autoremind.reports.survey')
    .factory('surveyService', ['$enhancedHttp', function ($enhancedHttp) {
        return {
            loadingIndicator: {
                refCount: 0,
                state: true
            },
            surveyReports: [],
            loadReports: function () {
                var self = this;
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/mock/survey.reports/',
                    disableErrorDialog: false,
                    retryBtn: true
                }, this.loadingIndicator)
                    .then(function (data) {
                    console.log('survey success', data);
                    self.surveyReports = data;
                }, function (error) {
                    console.log('survey error', error);
                });
            },
            getReportById: function (reportId) {
                for (var i in this.surveyReports) {
                    if (this.surveyReports[i].id === reportId) {
                        return this.surveyReports[i].url;
                    }
                }
            }
        };
    }]);
//# sourceMappingURL=survey.service.js.map